import React, { Component } from 'react';
import { Modal, Table, ProgressBar } from 'react-bootstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Papa from 'papaparse';

import { hideCsvResultsModal, clearCsvProcessingResults } from '../../actions';
import { NEW_IMPORTED_ITEM, UPDATE_IMPORTED_ITEM } from '../../constants/csvImportTypes';

class CsvResultsModal extends Component {
    render() {
        const {show, hideCsvResultsModal, clearCsvProcessingResults, data, totalCount} = this.props;

        let downloadErrorsLink = '';
        let downloadErrorsName = '';

        if (show) {
            const csvText = Papa.unparse(data
                .filter(result => result.error !== '')
                .map(result => ({
                    sourcePath:       result.item.sourcePath,
                    sourceRepository: result.item.sourceRepository,
                    sceneMediaID:     result.item.sceneMediaID,
                    sceneName:        result.item.sceneName,
                    datasetNum:       result.item.datasetNum,
                    mediaName:        result.item.mediaName,
                    language:         result.item.language,
                    description:      result.item.description,
                    error:            result.error
                })), {}
            );
            // UTF-8 BOM plus the text from papa
            const payload = new Blob(["\uFEFF",...csvText], {type: 'text/csv'});

            downloadErrorsLink = window.URL.createObjectURL(payload);
            downloadErrorsName = `Errors.csv`;
        }

        return (
            <Modal show={show} onHide={() => {
                clearCsvProcessingResults();
                hideCsvResultsModal();
            }}>
                <Modal.Header closeButton>
                    <Modal.Title> Your CSV is Processing! </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Below is a live log of the import process. Feel free to close this popup if you don&apos;t care bout the import results.
                    <br/>
                    <br/>
                    If there are any errors, you can download a CSV of <i>just the errors</i>, tweak it, and then retry processing.
                    <br/>
                    <br/>
                    <a href={downloadErrorsLink} download={downloadErrorsName}>Click here to download the errors.</a>
                    <hr/>
                    Import Progress: <ProgressBar active={data.length !== totalCount} bsStyle="info" now={(data.length/totalCount) * 100} />
                    <div className='pre-scrollable'>
                        <Table striped condensed responsive>
                            <thead>
                                <tr>
                                    <th>Action</th>
                                    <th>Dataset</th>
                                    <th>MediaName</th>
                                    <th>Error</th>
                                </tr>
                            </thead>

                            <tbody>
                                {data.map((result, i) => {
                                    return (
                                        <tr key={i}>
                                            <td>{typeToGlyphicon(result.type)}</td>
                                            <td>{result.item.datasetNum}</td>
                                            <td>{result.item.mediaName}</td>
                                            <td>{result.error}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </Table>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}

const typeToGlyphicon = type => {
    switch(type) {
        case NEW_IMPORTED_ITEM:
            return <span className='glyphicon glyphicon-plus'/>;
        case UPDATE_IMPORTED_ITEM:
            return <span className='glyphicon glyphicon-refresh'/>;
        default:
            return <span className='glyphicon glyphicon-minus'/>;
    }
};

const mapDispatchToProps = {
    hideCsvResultsModal,
    clearCsvProcessingResults
};

const mapStateToProps = state => ({
    show: state.ui.csvResults.show,
    data: state.ui.csvProcessingResults.results,
    totalCount: state.ui.csvProcessingResults.totalCount
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CsvResultsModal);

CsvResultsModal.propTypes = {
    show:                PropTypes.bool.isRequired,
    hideCsvResultsModal: PropTypes.func.isRequired,
    clearCsvProcessingResults: PropTypes.func.isRequired,
    data:                PropTypes.arrayOf(PropTypes.object).isRequired,
    totalCount: PropTypes.number.isRequired
};



// WEBPACK FOOTER //
// ./src/components/csv/CsvResultsModal.js